import { LegalShell } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <LegalShell title="Gizlilik Sözleşmesi ve KVKK Aydınlatma Metni" updated="Haziran 2026">
      <p>
        Ustayla.com (“Platform”) olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında
        kişisel verilerinizin güvenliğine önem veriyoruz. Bu metin, hangi verileri, hangi amaçla işlediğimizi ve
        haklarınızı açıklar.
      </p>

      <h2>1. İşlenen Kişisel Veriler</h2>
      <ul>
        <li><strong>Kimlik ve iletişim:</strong> ad-soyad, e-posta, telefon numarası.</li>
        <li><strong>Hesap ve kullanım:</strong> ilanlar, teklifler, mesajlar, cüzdan işlemleri.</li>
        <li><strong>Ödeme:</strong> ödemeler güvenli ödeme kuruluşu (iyzico) üzerinden alınır; kart bilgileriniz Platform sunucularında saklanmaz.</li>
        <li><strong>Teknik:</strong> IP adresi, oturum ve cihaz bilgileri.</li>
      </ul>

      <h2>2. İşleme Amaçları</h2>
      <ul>
        <li>Üyelik ve hesap yönetimi, hizmetlerin sunulması.</li>
        <li>Ödeme işlemlerinin gerçekleştirilmesi ve güvenliğin sağlanması.</li>
        <li>Yasal yükümlülüklerin yerine getirilmesi ve dolandırıcılığın önlenmesi.</li>
        <li>Talebiniz halinde bilgilendirme ve destek sağlanması.</li>
      </ul>

      <h2>3. Veri Güvenliği</h2>
      <p>
        Verileriniz <strong>256-bit SSL şifreleme</strong> ile korunan bağlantılar üzerinden aktarılır. Şifreler
        geri döndürülemez şekilde (hash) saklanır. Erişim yetkileri rol bazlı olarak sınırlandırılmıştır.
      </p>

      <h2>4. Verilerin Paylaşımı</h2>
      <p>
        Kişisel verileriniz, hizmetin gerektirdiği ölçüde ödeme kuruluşu ve yasal olarak yetkili kurumlarla
        paylaşılabilir. Telefon ve adres gibi iletişim bilgileriniz, yalnızca ilgili işlem için iletişim açan
        tarafla ve maskeleme kurallarımız çerçevesinde paylaşılır.
      </p>

      <h2>5. KVKK Kapsamındaki Haklarınız</h2>
      <p>
        KVKK m.11 uyarınca; verilerinize erişme, düzeltilmesini/silinmesini isteme ve işlemeye itiraz etme
        haklarına sahipsiniz. Taleplerinizi <strong>info@ustayla.com</strong> adresine iletebilirsiniz.
      </p>
    </LegalShell>
  );
}
